import type { Role } from '../core/constants/roles';

import demoSeed from './demo-accounts.json';
import { isDemoAuthEnabled } from './demoAuth';

export const DEMO_PASSWORD = demoSeed.password;

export interface DemoAccount {
  role: Role;
  email: string;
  login: string;
  name: string;
  houseId: string;
  houseIds?: string[];
  note?: string;
}

export const DEMO_ACCOUNTS = demoSeed.accounts as DemoAccount[];

/** Mock-mode login map: normalized login → role */
export const DEMO_LOGIN_BY_USERNAME: Record<string, Role> = Object.fromEntries(
  DEMO_ACCOUNTS.map((a) => [a.login.trim().toLowerCase(), a.role]),
) as Record<string, Role>;

export function resolveDemoRole(username: string): Role | null {
  const key = username.trim().toLowerCase();
  return DEMO_LOGIN_BY_USERNAME[key] ?? null;
}

export function isDemoCredential(username: string, password: string): boolean {
  if (!isDemoAuthEnabled()) return false;
  return password === DEMO_PASSWORD && resolveDemoRole(username) !== null;
}
